import { FeatureFlagConfig } from '../components/Feature';

export type EnvironmentTypes = 'develop' | 'staging' | 'production';
export interface awsRumEnvKeysConfig {
  // aws keys used to connect to aws rum
  develop: string;
  staging: string;
  production: string;
}

export interface LaunchDarklyEnvConfig {
  // launch darkly client IDs
  develop: string;
  staging: string;
  production: string;
}
export interface ConfigurationStateInterface {
  baseUrl: string; // base url of the main API
  tpCoreApiUrl: string;
  compSearchApiUrl: string; // Comp Search API
  docApiUrl: string; // base url of platform docuemnt API
  tpReportGeneratorApiUrl: string; // base url of TP Report Generator API
  authUrl: string; // base url of auth stack
  loginStackRelativeUrl: string; // realtive path for generic login page
  microUIReportsStackRelativeUrl: string;
  reportsApiUrl: string; // base url of ReportsApi stack
  complianceCentralApiUrl: string; // base url of Compliance Central API
  planningApiUrl: string; // base url of planning lambda
  planningWebSocketUrl: string; // base url of planning web socket
  principleUrl: string; // base url of principle api
  adminUrl: string; // base url of admin stack
  proxyUrl: string; // base url of platform proxy
  xbsEnvironment: EnvironmentTypes;
  xbsEnvironmentShort: string;
  buildTime: string;
  clientAppId: string;
  tinyMCEApiKey: string;
  featureFlags: FeatureFlagConfig;
  awsRumEnvKeys: awsRumEnvKeysConfig;
  launchDarklyEnv: LaunchDarklyEnvConfig;
  googleAnalyticsTrackId: Record<EnvironmentTypes, string>;
}

declare global {
  interface Window {
    configuration: ConfigurationStateInterface;
  }
}

export const getAppConfig = (): ConfigurationStateInterface => window.configuration || {};
